// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/app.sass
// module id = 409
// module chunks = 100